import {computed, inject} from '@angular/core';
import {rxResource, toSignal} from '@angular/core/rxjs-interop';
import { signalStore, withComputed, withMethods, withProps} from '@ngrx/signals';
import {WorksApi} from "../../../../../core/data/works/works.api";
import {ActivatedRoute} from "@angular/router";

export interface SliderImage {
  image: string;
  thumbImage: string;
  alt?: string;
  title?: string;
}

export const WorkStore = signalStore(
  withProps((_, workApi = inject(WorksApi), route = inject(ActivatedRoute)) => {
    const routeParams = toSignal(route.params);
    const _documentId = computed(() => routeParams()?.['id']);
    return {
      _work: rxResource({
        stream: () => workApi.getWorkDetails(_documentId()),
      })
    };
  }),
  withComputed(({ _work }) => {
    return {
      isLoading: computed(
        () => _work.isLoading(),
      ),
      error: computed(
        () => _work.error() ?? null,
      ),
      work: computed(() => (_work.hasValue() ? _work.value() : null)),
      images: computed<SliderImage[]>(() =>
        _work.value() ? mapToImageUrls(_work.value()) : [],
      ),
    };
  }),
  withMethods((store) => ({
    reload(): void {
      if (store._work.error()) {
        store._work.reload();
      }
    },
  })),
);


function mapToImageUrls(items: any | null) {
  return (
    items?.images?.map((img:any) => ({
      image: img.url,
      thumbImage: img.formats?.large?.url ?? img.formats?.medium?.url ?? img.url,
      alt: img.alternativeText ?? '',
      title: img.caption ?? '',
    })) ?? []
  );
}
